
import {defineComponent, PropType} from 'vue';
import Branding from './Branding.vue';
import MainMenu from './MainMenu.vue';
import MenuItem from './types';
import Icon from '@ohrm/oxd/core/components/Icon/Icon.vue';

export default defineComponent({
  name: 'oxd-side-panel',

  emits: ['collapse'],

  props: {
    toggle: {
      type: Boolean,
      default: false,
    },
    brandLogoSrc: {
      type: String,
      default: '',
    },
    brandBannerSrc: {
      type: String,
      default: '',
    },
    homeUrl: {
      type: String,
      default: '/',
    },
    menuItems: {
      type: Object as PropType<MenuItem[]>,
      default: [],
    },
  },

  components: {
    'oxd-branding': Branding,
    'oxd-main-menu': MainMenu,
    'oxd-icon': Icon,
  },

  computed: {
    classes(): object {
      return {
        toggled: this.toggle,
      };
    },
  },
});
